import {
    HashtagCreatorObj,
    HashtagDetailedObj,
    HashtagObj
} from "utils/types/general.types";

export const hashtags: HashtagObj[] = [
    {
        id: 1,
        name: "name1",
        count: 25,
        suspended: false,
        deleted: false
    },
    {
        id: 2,
        name: "name2",
        count: 15,
        suspended: true,
        deleted: false
    },
    {
        id: 3,
        name: "name3",
        count: 250,
        suspended: false,
        deleted: true
    },
    {
        id: 4,
        name: "name4",
        count: 45,
        suspended: false,
        deleted: false
    },
    {
        id: 5,
        name: "name5",
        count: 20,
        suspended: false,
        deleted: false
    },
    {
        id: 6,
        name: "name6",
        count: 15,
        suspended: false,
        deleted: true
    },
    {
        id: 7,
        name: "name7",
        count: 5,
        suspended: false,
        deleted: false
    },
    {
        id: 8,
        name: "name8",
        count: 46,
        suspended: true,
        deleted: false
    },
    {
        id: 9,
        name: "name9",
        count: 99,
        suspended: false,
        deleted: false
    },
    {
        id: 10,
        name: "name10",
        count: 87,
        suspended: false,
        deleted: false
    },
    {
        id: 11,
        name: "name11",
        count: 36,
        suspended: false,
        deleted: false
    },
    {
        id: 12,
        name: "name12",
        count: 2,
        suspended: true,
        deleted: false
    },
    {
        id: 13,
        name: "name13",
        count: 205,
        suspended: false,
        deleted: false
    }
];

export const hashtagCreators: HashtagCreatorObj[] = [
    {
        id: 1,
        user: {
            id: 6,
            name: "Satish Chauhan",
            username: "demo32",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1706690469_profile.jpg"
        },
        createdAt: "2024-04-24 19:18",
        country: {
            value: "IN",
            label: "India",
            flag: "https://flagcdn.com/in.svg"
        },
        noPosts: 5
    },
    {
        id: 2,
        user: {
            id: 7,
            name: "shah rukh khan",
            username: "shahrukhkhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906495_profile.jpg"
        },
        createdAt: "2024-04-25 19:18",
        country: {
            value: "IN",
            label: "India",
            flag: "https://flagcdn.com/in.svg"
        },
        noPosts: 5
    },
    {
        id: 3,
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        createdAt: "2024-04-25 19:50",
        country: {
            value: "IN",
            label: "India",
            flag: "https://flagcdn.com/in.svg"
        },
        noPosts: 5
    },
    {
        id: 4,
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        createdAt: "2024-04-25 21:10",
        country: {
            value: "IN",
            label: "India",
            flag: "https://flagcdn.com/in.svg"
        },
        noPosts: 5
    },
    {
        id: 5,
        user: {
            id: 4,
            name: "Momeento News",
            username: "momeento_news",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
        },
        createdAt: "2024-04-25 22:00",
        country: {
            value: "IN",
            label: "India",
            flag: "https://flagcdn.com/in.svg"
        },
        noPosts: 5
    },
    {
        id: 6,
        user: {
            id: 1,
            name: "salman khan",
            username: "salmankhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906284_profile.jpg"
        },
        createdAt: "2024-04-26 13:18",
        country: {
            value: "IN",
            label: "India",
            flag: "https://flagcdn.com/in.svg"
        },
        noPosts: 5
    },
    {
        id: 7,
        user: {
            id: 3,
            name: "Abdulaziz Al Khaldi",
            username: "azizalkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg"
        },
        createdAt: "2024-04-26 18:18",
        country: {
            value: "IN",
            label: "India",
            flag: "https://flagcdn.com/in.svg"
        },
        noPosts: 5
    }
];

export const hashtagDetail: HashtagDetailedObj = {
    id: 1,
    name: "name1",
    count: 25,
    suspended: false,
    deleted: false,
    creators: hashtagCreators,
    TopActiveUsers: [
        {
            id: 1,
            name: "salman khan",
            username: "salmankhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906284_profile.jpg"
        },
        {
            id: 3,
            name: "Abdulaziz Al Khaldi",
            username: "azizalkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg"
        },
        {
            id: 4,
            name: "Momeento News",
            username: "momeento_news",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
        },
        {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        {
            id: 6,
            name: "Satish Chauhan",
            username: "demo32",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1706690469_profile.jpg"
        },
        {
            id: 7,
            name: "shah rukh khan",
            username: "shahrukhkhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906495_profile.jpg"
        },
        {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        }
    ],
    noUsers: 7,
    noPostsInc: 35
};

/*
,{
    id: 1,
    user: {
        id: 6,
        name: "Satish Chauhan",
        username: "demo32",
        url: "https://momeento.nyc3.digitaloceanspaces.com/images/1706690469_profile.jpg"
    },
    createdAt: "2024-04-24 19:18",
    country: {
        value: "IN",
        label: "India",
        flag: "https://flagcdn.com/in.svg"
    }
}
*/
